<template lang="pug">
  div( :id="key_id" )
    b-row
      b-col( cols="8") {{name}}
      b-col( cols="4")

</template>

<script>
export default {
name: "CustomerOrderItemRO",
  props: {
    customer_id: [Number, String],
    objects: Array,
  },
  data(){
    return {

    }
  },
  computed:{
    name() {
      let customer;
      customer = _.find(this.objects, {value: String(this.customer_id)});
      return customer ? customer.text : 'Не найден';
    },

  }
}
</script>

<style scoped>

</style>